import React, { useState } from 'react';
import {
  BetResponseCode,
  isMobile,
  notificationStore,
  useInputValueChangingFunctions,
  useTranslation,
} from '@pascal/pascal-core';
import {
  AdditionalInputValueChangingButtons,
  InputTypesForChanging,
} from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';
import { globalTranslationKeys } from '../../enums/translationKeys';

const BetAmountSection = ({
  bet,
  doBet,
  index,
  isDemo,
  limits,
  section,
  wageringOdd,
  activeFreeBet,
  // betSections,
  handleInputClick,
  disabledBetButton,
  handleBetSectionsState,
  // handleChangeInputValue,
}) => {
  const t = useTranslation();
  const [isValidatedAmount, setIsValidatedAmount] = useState(false);

  const decidedCallBackCall = (callback) => {
    if (isValidatedAmount) {
      setIsValidatedAmount(false);
    } else {
      callback();
    }
  };

  const { handleChangeInputValue } = useInputValueChangingFunctions({
    changingValue: section.betAmount,
    changingValueCallback: handleBetSectionsState,
    additionalInputInfo: {
      inputType: InputTypesForChanging.BetInput,
    },
    isTableLine: true,
  });

  const handleInputBlur = (e) => {
    const { value } = e.target;
    const { minBet, maxBet } = limits;
    // let stake;
    if (!value || Number(value) < minBet) {
      notificationStore.setNotificationType(BetResponseCode.InValidMinBetWithValue);
      setIsValidatedAmount(true);
      // stake = minBet;
      handleBetSectionsState(minBet, index);
    } else if (Number(value) > maxBet) {
      notificationStore.setNotificationType(BetResponseCode.InValidMaxBetWithValue);
      setIsValidatedAmount(true);
      handleBetSectionsState(maxBet, index);
    } else {
      handleBetSectionsState(e.target.value, index);
    }
  };

  return (
    <>
      <div className='gameCenterBetSectionTopBlock'>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button
          type='button'
          disabled={activeFreeBet.id}
          className={`plusMinusButton icon-minus minus ${activeFreeBet.id ? 'disabled' : ''}`}
          data-role='minus'
          onClick={() =>
            handleChangeInputValue(AdditionalInputValueChangingButtons.minus, 2, index)
          }
        />
        <input
          inputMode={isMobile() ? 'none' : 'text'}
          type='text'
          className='gameCenterBetAmountInput'
          value={activeFreeBet.id && !isDemo ? activeFreeBet.amount : bet || ''}
          onChange={(e) => {
            if (
              /^([0]{1}|([1-9]{1}\d*))(?:\.\d{0,2})?$/.test(e.target.value) ||
              e.target.value === ''
            ) {
              handleBetSectionsState(e.target.value.replace(',', '.'), index);
            }
          }}
          onBlur={handleInputBlur}
          maxLength={9}
          onTouchStart={() => handleInputClick(index)}
          onMouseDown={() => handleInputClick(index)}
          onClick={() => handleInputClick(index, true)}
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button
          type='button'
          className={`plusMinusButton icon-plus plus ${activeFreeBet.id ? 'disabled' : ''}`}
          disabled={activeFreeBet.id}
          data-role='plus'
          onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.plus, 2, index)}
        />
      </div>
      <div className='gameCenterBetSectionMiddleBlock'>
        <button
          type='button'
          className='gameCenterBetSectionMiddleBtn'
          disabled={activeFreeBet.id && !isDemo}
          onClick={() =>
            handleChangeInputValue(AdditionalInputValueChangingButtons.divide, 2, index)
          }
        >
          1/2
        </button>
        <button
          type='button'
          className='gameCenterBetSectionMiddleBtn'
          disabled={bet === limits?.minBet || (activeFreeBet.id && !isDemo)}
          onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.min, 2, index)}
        >
          {t(globalTranslationKeys.Min)}
        </button>
        <button
          type='button'
          className='gameCenterBetSectionMiddleBtn'
          disabled={activeFreeBet.id && !isDemo}
          onClick={() =>
            handleChangeInputValue(AdditionalInputValueChangingButtons.allIn, 2, index)
          }
        >
          {t(globalTranslationKeys.AllIn)}
        </button>
        <button
          type='button'
          className='gameCenterBetSectionMiddleBtn'
          disabled={activeFreeBet.id && !isDemo}
          onClick={() =>
            handleChangeInputValue(AdditionalInputValueChangingButtons.multiply, 2, index)
          }
        >
          x2
        </button>
      </div>

      <div className={`gameCenterBetSectionBottomBlock ${disabledBetButton[index] ? '' : 'pulse'}`}>
        <button
          className={`gameCenterBetBtn ${activeFreeBet.id || wageringOdd ? 'free-bet' : ''} `}
          data-type='bet'
          type='button'
          onClick={() => decidedCallBackCall(() => doBet(section.index))}
          disabled={disabledBetButton[index]}
        >
          <p className='gameCenterCashBtnTxt'>
            {activeFreeBet.id && !isDemo
              ? `${t(globalTranslationKeys.FreeBet)} ${activeFreeBet?.remainingCount}`
              : t(globalTranslationKeys.Bet)}
          </p>
          <p className={`btnGameSmallTxt ${disabledBetButton[index] ? 'disabled' : ''}`}>
            {!isDemo && ((activeFreeBet.id && !activeFreeBet.isMinOddNull) || wageringOdd)
              ? `${t(globalTranslationKeys.MinOdd)} x${
                  activeFreeBet?.id && !activeFreeBet.isMinOddNull
                    ? activeFreeBet.minOdd
                    : wageringOdd
                }`
              : ''}
          </p>
        </button>
      </div>
    </>
  );
};
export default BetAmountSection;
